// NewDatabaseGraphToggle.tsx
import React from 'react';
import { BarChart3 } from 'lucide-react';
import './NewDatabaseGraphToggle.css';

interface NewDatabaseGraphToggleProps {
    showGraph: boolean;
    onChange: (show: boolean) => void;
}

const NewDatabaseGraphToggle: React.FC<NewDatabaseGraphToggleProps> = ({ 
    showGraph, 
    onChange 
}) => {
    return (
        <div className="newdb-view-toggle-container">
            <button
                className={`newdb-view-toggle-button ${showGraph ? 'active' : ''}`}
                onClick={() => onChange(!showGraph)}
                title={showGraph ? 'Hide Graph' : 'Show Graph'}
            >
                <BarChart3 size={18} />
                <span>{showGraph ? 'Hide Graph' : 'Show Graph'}</span>
            </button>
        </div>
    );
};

export default NewDatabaseGraphToggle;
